import { Route, Routes } from 'react-router-dom';
import AppLayout from '@/components/layout/AppLayout';
import { ROUTE_PATTERNS } from '@/constants/routes';
import DashboardPage from '@/pages/DashboardPage';
import NewsletterListPage from '@/pages/NewsletterListPage';
import NewsletterEditorPage from '@/pages/NewsletterEditorPage';
import NewsletterPreviewPage from '@/pages/NewsletterPreviewPage';
import VersionHistoryPage from '@/pages/VersionHistoryPage';
import NotFoundPage from '@/pages/NotFoundPage';

export default function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path={ROUTE_PATTERNS.dashboard} element={<DashboardPage />} />
        <Route path={ROUTE_PATTERNS.newsletterList} element={<NewsletterListPage />} />
        <Route path={ROUTE_PATTERNS.newsletterCreate} element={<NewsletterEditorPage />} />
        <Route path={ROUTE_PATTERNS.newsletterEdit} element={<NewsletterEditorPage />} />
        <Route path={ROUTE_PATTERNS.newsletterPreview} element={<NewsletterPreviewPage />} />
        <Route path={ROUTE_PATTERNS.newsletterVersions} element={<VersionHistoryPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
